import * as R from '@radix-ui/react-dialog';
import type { ComponentChildren } from 'preact';
import { cn } from '../lib/cn';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ComponentChildren;
}

export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
}: Props) {
  return (
    <R.Root open={open} onOpenChange={onOpenChange}>
      <R.Portal>
        <R.Overlay class={cn('fixed inset-0 bg-black/30 backdrop-blur-sm')} />
        <R.Content
          class={cn(
            'fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2',
            'rounded-lg bg-surface p-6 shadow-2xl',
          )}
        >
          <R.Title class="text-lg font-semibold">{title}</R.Title>
          {description && (
            <R.Description class="mt-1 text-sm text-surface-muted">
              {description}
            </R.Description>
          )}
          <div class="mt-4">{children}</div>
        </R.Content>
      </R.Portal>
    </R.Root>
  );
}
